import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const WaitlistForm = ({ productId = null, title, text, testid = "waitlist" }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/waitlist", { email, productId });
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-[#E5E0D8] bg-[#F7F4EE] p-6 sm:p-8" data-testid={`${testid}-box`}>
      <p className="eyebrow">{title}</p>
      <p className="mt-4 text-sm leading-relaxed text-[#5A626A]">{text}</p>
      {done ? (
        <p className="mt-6 font-display text-xl italic" data-testid={`${testid}-success`}>You're on the list. You'll hear first when similar work is ready.</p>
      ) : (
        <form onSubmit={submit} className="mt-6 flex flex-col gap-5 sm:flex-row sm:items-end">
          <label className="flex-1">
            <span className="field-label">Email address</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="field" data-testid={`${testid}-email-input`} />
          </label>
          <button type="submit" disabled={busy} className="btn-primary" data-testid={`${testid}-submit-btn`}>{busy ? "Joining…" : "Join the waitlist"}</button>
        </form>
      )}
    </div>
  );
};
